import { useMemo, useState } from "react";
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Skeleton,
  InputRightElement,
  Input,
  InputGroup,
  Image,
} from "@chakra-ui/react";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import { useCategories } from "../../categorys/deviceActivityLog/index";
import { useDeviceActivityLog } from "../../hooks/useDeviceActivityLog";
import SearchableSelect from "../../components/selectForm";
import useDebounce from "../../hooks/useDebounce";
import { useCallback } from "react";
import { SearchIcon } from "@chakra-ui/icons";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";

const ActionData = [
  {
    key: "LOGIN",
    value: "Đăng nhập",
  },
  {
    key: "CHECKIN",
    value: "Chấm công",
  },
];

const TableDeviceActivityLog = () => {
  // table
  const [search, setSearch] = useState("");
  const [employeeId, setEmployeeId] = useState(null);
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [department, setDepartment] = useState(null);
  const [action, setAction] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [zIndex, setZIndex] = useState(1);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    deviceActivityLog,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useDeviceActivityLog(
    debouncedSearchTerm,
    employeeId,
    action,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
    department
  );

  const tableData = {
    headers: [
      {
        label: "STT",
        key: "",
      },
      {
        label: "Mã NV",
        key: "code",
      },
      {
        label: "Tên NV",
        key: "name",
      },
      {
        label: "Hành động",
        key: "actionDetail",
      },
      {
        label: "Mã thiết bị",
        key: "deviceCode",
      },
      {
        label: "Loại thiết bị",
        key: "deviceName",
      },
      {
        label: "Phiên bản APP",
        key: "appVersion",
      },
      {
        label: "Ngày tạo",
        key: "createdAt",
      },
    ],
    data: deviceActivityLog,
  };

  const { constantData } = useCategories();

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const employees = useMemo(() => {
    if (!constantData?.employee) return [];

    return Object.entries(constantData.employee).map(
      ([id, { fullName, code }]) => ({
        key: id,
        value: `${fullName} (${code})`,
      })
    );
  }, [constantData?.employee]);

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );

  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  const departments = useMemo(
    () => formatEntries(constantData?.departmentByNumbers),
    [constantData?.departmentByNumbers]
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Tên NV, mã NV, loại thiết bị, phiên bản app... "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOption={{ key: 0, value: "Chọn nhân viên" }}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={ActionData}
                  initialSelectedOption={{ key: 0, value: "Chọn hành động" }}
                  setValue={setAction}
                />
                <SearchableSelect
                  isShowSearch={false}
                  options={saleBlocks}
                  initialSelectedOption={{ key: 0, value: "Chọn khối" }}
                  setValue={setSaleBlockId}
                />
                <SearchableSelect
                  isShowSearch={false}
                  options={saleAreas}
                  initialSelectedOption={{ key: 0, value: "Chọn vùng" }}
                  setValue={setSaleAreaId}
                />
                <SearchableSelect
                  isShowSearch={false}
                  options={departments}
                  initialSelectedOption={{ key: 0, value: "Loại nhân viên" }}
                  setValue={setDepartment}
                />
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày tạo từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "name") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "actionDetail") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "appVersion") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "deviceCode") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "deviceName") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 16px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "actionDetail") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "appVersion") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "deviceName") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "deviceCode") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default TableDeviceActivityLog;
